var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M6 6H22V22H6z",
    transform: "rotate(-180 14 14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M26 6H42V22H26z",
    transform: "rotate(-180 34 14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M26 26H42V42H26z",
    transform: "rotate(-180 34 34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M6 26H22V42H6z",
    transform: "rotate(-180 14 34)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/microsoft-logo.c63dc619752ec3508cf87a55756dd96c.svg";
export { ForwardRef as ReactComponent };